﻿import * as React from 'react';
import { Table } from 'react-bootstrap';
import { IOrderListItem } from '../../../Entities';
import { Translate } from '../../../../../shared/LanguageService';
import OrderListRow from '../../../OrderListRow';

type OrderListProps = {
    orders: IOrderListItem[];
    user: any;
    navigateTo: (route: string) => void;
    newOrderId: string;
};

function OrderList({ orders, user, navigateTo, newOrderId }: OrderListProps) {
    return (
        <div>
            <Table className="order-table" hover responsive>
                <thead>
                    <tr>
                        <th className="hidden-sm hidden-xs">
                            {Translate('orders/list/header/order-collection-number')}
                        </th>
                        <th className="hidden-sm hidden-xs">
                            {Translate('orders/list/header/order-placed-at')}
                        </th>
                        <th>{Translate('orders/list/header/booked')}</th>
                        <th>{Translate('orders/list/header/photographer')}</th>
                        <th className="hidden-sm hidden-xs">
                            {Translate('orders/list/header/package')}
                        </th>
                        <th>{Translate('orders/list/header/address')}</th>
                        <th className="hidden-sm hidden-xs">
                            {Translate('orders/list/header/status')}
                        </th>
                        <th className="hidden-sm hidden-xs" />
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {orders.map((order: IOrderListItem, index: number) => (
                        <OrderListRow
                            includeAddress={true}
                            order={order}
                            key={index}
                            user={user}
                            navigateTo={navigateTo}
                            isNewOrder={newOrderId === order.id.toString()}
                        />
                    ))}
                </tbody>
            </Table>
        </div>
    );
}

export default OrderList;
